<template>
  <div>
    <div class="coupon-coin-wrap">
      <div class="coupon-coin-box">
        <h3 class="coupon-coin-hd">Wavve 쿠폰 등록</h3>
        <div class="coupon-wrapper">
          <input type="text" id="coupon-register" class="coupon-register" placeholder="쿠폰번호를 입력해 주세요"
                     v-model="couponNumber" v-on:keyup="checkCodeCount">
          <label for="coupon-register">
            <span class="a11y-hidden">쿠폰 번호 입력</span>
          </label>
        </div>
        <button type="button" :class="enableCouponRegisterButton ? 'btn-coupon on' : 'btn-coupon'"
                @click.prevent="registerCoupon"
        >등록</button>
        <ul class="coupon-coin-exclamation">
          <li>쿠폰번호에 숫자 0,1은 없습니다. 영문자 O,I와 혼동하지 않도록 유의해주세요.</li>
          <li>쿠폰으로 지급되는 상품은 기존 보유 상품과 중복되어 적용되므로 가급적 이용중인 상품이 만료 된 뒤에 쿠폰을 사용해 주세요.</li>
          <li>유효기간이 지난 쿠폰은 등록하실 수 없습니다.</li>
          <li>등록하신 쿠폰은 환불되지 않습니다.</li>
          <li>쿠폰은 상업적 용도로 사용하거나 매매하실 수 없습니다.</li>
        </ul>
      </div>

      <div class="coupon-coin-box">
        <h3 class="coupon-coin-hd">코인충전</h3>
        <span class="coin-link">
                <p class="coin-txt">
                    <span>코인을 충전하시면 <strong>단건 구매시</strong></span>
                    <span><strong>쉽고 빠르게 구매</strong>하실 수 있습니다.</span>
                </p>
                <button type="button" class="btn-coin" @click.prevent="chargeCoin">충전하기</button>
            </span>
        <ul class="coupon-coin-exclamation">
          <li>충전하신 코인의 유효기간은 5년이며 유효기간이 지난 코인은 소멸되어 사용하실 수 없습니다.</li>
          <li>한 ID당 보유할 수 있는 총 코인은 20만원 이하입니다. </li>
          <li>자동결제 시 보유 코인이 20만원 이상인 경우 자동으로 결제가 해지됩니다.</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '@/common/util/utils'
import {
  MSG_MOVING_MYPOOQ_COIN,
  MSG_MOVING_MYPOOQ_COUPON,
  MSG_MYPOOQ_COUPON_NO_VALUE, PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE,
  PAYMENT_GATE_TYPE_ONE_STORE
} from '@/common/constant'
import { commonErrorProcess, MyPooqService } from '@/common/api/api.service'
import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'
export default {
  name: 'RegistVoucher',
  data () {
    return {
      couponNumber: '',
      device: utils.cookies.getDevice(),
      enableCouponRegisterButton: false
    }
  },
  methods: {
    registerCoupon () {
      if (this.couponNumber.trim().length === 0) {
        utils.alert(MSG_MYPOOQ_COUPON_NO_VALUE)
        return
      }
      MyPooqService.myCouponRegister({ couponnumber: this.couponNumber }).then(async (response) => {
        if (this.device === DEVICE_TYPE_ANDROID) {
          try {
            window.Android.registerVoucherCoupon(response.data.coupontypeid)
          } catch (err) {
            console.log(err)
          }
        }
        // 안드로이드는 앱 자체적으로 confirm 띄우므로 리턴
        if (this.device === DEVICE_TYPE_ANDROID) {
          return
        }
        if (response.data.coupontypeid === '3' && await utils.asyncConfirm(MSG_MOVING_MYPOOQ_COIN)) {
          window.location.href = '/mypooq/coin.html'
        } else if (response.data.coupontypeid !== '3' && await utils.asyncConfirm(MSG_MOVING_MYPOOQ_COUPON)) {
          window.location.href = '/mypooq/coupon.html'
        }
      }).catch(async (error) => {
        if (error.response && error.response.status === 550) {
          if (error.response.data.resultcode === '210') {
            if (this.device === DEVICE_TYPE_ANDROID) {
              utils.alert('로그인 후 등록하실 수 있습니다. 로그인해 주세요.')
            } else {
              const moveToLoginPage = await utils.asyncConfirm(error.response.data.resultmessage)
              if (moveToLoginPage) {
                location.href = `/login?referer=${encodeURIComponent(location.pathname + location.search)}`
              }
            }
          } else {
            commonErrorProcess(error)
          }
        }
      })
    },
    chargeCoin () {
      if (this.device === DEVICE_TYPE_ANDROID) {
        try {
          const url = encodeURIComponent(window.location.origin + '/callback.html?action=ClosePopup')
          const pgName = utils.getPgName()
          if (pgName === PAYMENT_GATE_TYPE_ONE_STORE) {
            window.Android.clickOneStoreChargeCoin(url, pgName)
          } else if (pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE) {
            const url = encodeURIComponent(window.location.origin + '/callback.html?action=ClosePopupAndReload')
            window.Android.openChargeCoinWebview(url, pgName)
          } else {
            window.Android.clickChargeCoin(url)
          }
        } catch (err) {
          console.log(err)
        }
      } else {
        utils.common.showCoinPopup(false, window.location.origin + '/callback.html?action=ClosePopupAndReload')
      }
    },
    checkCodeCount (e) {
      const value = e.target.value
      this.enableCouponRegisterButton = !!(value && value.length > 0)
    }
  }
}
</script>
<style scoped>
  .coupon-wrapper{
    border-radius: 5px;
  }
  .coupon-register{
    width: 100%;
    height: 47px;
    border: 1px solid #2f2f2f;
    border-radius: 5px;
    outline: none;
    background-color: #2f2f2f;
    font-size: 14px;
    line-height: 51px;
    color: #fff;
    text-align: center;
  }
  .coupon-register:focus{
    border: 1px #2f2f2f solid;
    outline: none;
  }
  input[type=text].coupon-register::-webkit-input-placeholder{color: #a5a5a5;}
  input[type=text].coupon-register:-moz-placeholder{color: #a5a5a5;}
  input[type=text].coupon-register::-moz-placeholder{color: #a5a5a5;}
  input[type=text].coupon-register:-ms-input-placeholder{color: #a5a5a5;}

  input:focus::-webkit-input-placeholder{ /* WebKit browsers */ color:transparent; }
  input:focus:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ color:transparent; }
  input:focus::-moz-placeholder{ /* Mozilla Firefox 19+ */ color:transparent; }
  input:focus:-ms-input-placeholder { /* Internet Explorer 10+ */ color:transparent}
</style>
